import React from 'react';
import { motion } from 'framer-motion';
import { BatteryWarning, BrainCircuit } from 'lucide-react';
export function PainSection() {
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-100">
      <div className="max-w-3xl mx-auto" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="space-y-12" data-id="element-102">
          <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-103">
            <div className="bg-brand-coral/10 p-4 rounded-2xl flex-shrink-0" data-id="element-104">
              <BatteryWarning className="w-8 h-8 text-brand-coral" data-id="element-105" />
            </div>
            <div data-id="element-106">
              <p className="text-lg md:text-xl text-brand-navy leading-relaxed" data-id="element-107">
                Llegas de trabajar exhausta. Quieres un abrazo, una charla, o
                simplemente una cena tranquila. Pero tu hijo está en otro mundo.{' '}
                <strong className="text-brand-coral" data-id="element-108">
                  YouTube Kids se ha convertido en su "niñera"
                </strong>
                , y cuando intentas poner un límite, ocurre el desastre: gritos,
                llanto extremo y una agresividad que te asusta.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-109">
            <div className="bg-brand-navy/10 p-4 rounded-2xl flex-shrink-0" data-id="element-110">
              <BrainCircuit className="w-8 h-8 text-brand-navy" data-id="element-111" />
            </div>
            <div data-id="element-112">
              <p className="text-lg md:text-xl text-brand-navy leading-relaxed" data-id="element-113">
                Sientes culpa. Culpa por dejarlo frente a la pantalla para poder
                cocinar, y culpa por no saber cómo detenerlo. El miedo es real:{' '}
                <strong className="italic" data-id="element-114">
                  ¿Qué pasará con su cerebro en 5 años? ¿Se convertirá en un
                  adolescente antisocial?
                </strong>{' '}
                El costo de no actuar hoy es ver cómo su capacidad de atención y
                su curiosidad natural se apagan día tras día.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}